import { PAGE_SIZE_OPTIONS } from '@/lib/useTablePageSize';

interface Props {
  value: number;
  onChange: (n: number) => void;
  label?: string;
}

export default function TablePageSize({ value, onChange, label = 'Rows per page' }: Props) {
  return (
    <label className="table-page-size">
      <span>{label}</span>
      <select value={value} onChange={e => onChange(Number(e.target.value))}>
        {PAGE_SIZE_OPTIONS.map(n => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
      </select>
    </label>
  );
}
